<div class="action-set-copilot-authentication-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="action-set-copilot-authentication-dialog-header">
    <div class="title">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.actionName' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="action-set-copilot-authentication-dialog-body">
    <div class="title">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.title' | labelsProvider }}
    </div>
    <mat-radio-group [(ngModel)]="selectedOption">
      <mat-radio-button [value]="powerplatformCopilotAuthenticationTypeEnum.noAuthentication">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.noAuthentication' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.noAuthenticationDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="powerplatformCopilotAuthenticationTypeEnum.permittedUsersOnly">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.permittedUsersOnly' | labelsProvider }}
      </mat-radio-button>
      <br />
      <div class="space">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.permittedUsersOnlyDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="powerplatformCopilotAuthenticationTypeEnum.signinRequiredCustomWebsite">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.signinRequiredCustomWebsite' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{
          'commonActions.powerplatformSetCopilotAuthentication.signinRequiredCustomWebsiteDescription' | labelsProvider
        }}
      </div>
    </mat-radio-group>
  </div>
  <div class="action-set-copilot-authentication-dialog-footer">
    <button class="button" cdkFocusInitial (click)="applyClicked()" [ngClass]="{ 'button-disabled': !selectedOption }">
      <span>{{ 'commonActions.powerplatformSetCopilotAuthentication.applyButton' | labelsProvider }}</span>
    </button>
    <div class="disclaimer">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.disclaimer1' | labelsProvider }}
    </div>
    <div class="disclaimer">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.disclaimer2' | labelsProvider }}
    </div>
    <div class="disclaimer">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.disclaimer3' | labelsProvider }}
    </div>
  </div>
</div>
